import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";

const SeeAllToursButton = () => {
  const { pathname } = useLocation();
  if (pathname === "/tours") return null;

  return (
    <Link
      to="/tours"
      aria-label="See all Cambodia tours"
      className="fixed bottom-6 left-6 z-50 hidden md:flex items-center gap-2 bg-background/90 backdrop-blur-sm border border-border shadow-soft text-foreground hover:text-primary hover:border-primary transition-colors px-3 py-2 rounded-full"
    >
      <Compass className="h-5 w-5 md:h-6 md:w-6" aria-hidden="true" />
      <span className="text-[11px] md:text-sm uppercase tracking-[0.25em] font-medium">
        See all Cambodia tours
      </span>
    </Link>
  );
};

export default SeeAllToursButton;
